import DataSource from '../entities/dataSource';

const DataSourceDataTransformationAfterFetch = (data: any) => {
    return data.map((row: any) => {
        return new DataSource(row);
    });
};

export default DataSourceDataTransformationAfterFetch;
